import { GiServerRack, GiMicroscope } from "@onemind-services-llc/react-icons-ng/gi";
import { IoServerOutline } from "@onemind-services-llc/react-icons-ng/io5";
import { AiOutlineCloudServer } from "@onemind-services-llc/react-icons-ng/ai";
import { BsFillHddNetworkFill } from "@onemind-services-llc/react-icons-ng/bs";
import { BiCloudUpload, BiNetworkChart } from "@onemind-services-llc/react-icons-ng/bi";
import { FiMonitor } from "@onemind-services-llc/react-icons-ng/fi";
import { MdOutlineRestorePage } from "@onemind-services-llc/react-icons-ng/md";
import {
  TbOutlineReportAnalytics,
  TbOutlineSettingsAutomation,
  TbOutlineCloudComputing,
} from "@onemind-services-llc/react-icons-ng/tb";

export const Ansible_Reason = [
  "Ansible is an open-source community project sponsored by Red Hat. It's the simplest way to automate IT, serving as the only automation language that can be used across entire IT teams—from systems and network administrators to developers and managers.",
  "Red Hat® Ansible® Automation Platform is an end-to-end automation platform designed to configure systems, deploy software, and orchestrate advanced workflows. It includes resources to create, manage, and scale automation across the entire enterprise, making it ideal for implementing network infrastructure as code and CI/CD for networking.",
];

export const WhyAnsibleList = [
  {
    title: "Zero Setup Time",
    desc: "Launch an Ansible Instant Env with just a few clicks, with all the tools and the CloudMyLab tech stack at your fingertips.",
  },
  {
    title: "Pre-Built Playbooks and Modules",
    desc: "Jumpstart your network automation with our extensive library of pre-built playbooks and modules. Tailored for efficiency, these tools are ready to deploy, saving you time and effort.",
  },
  {
    title: "Cloud-Hosted Environment",
    desc: "Experience the freedom of a cloud-hosted setup. No need for complex installations or managing hardware – access powerful network automation tools from anywhere, anytime.",
  },
  {
    title: "Real-Life Use Case Templates",
    desc: "Explore our collection of real-life use case templates. Designed to mirror industry standards, they provide a solid foundation for your network CI/CD projects.",
  },
  {
    title: "Rapid Deployment",
    desc: "Get up and running in minutes. Our Ansible Instant Env is designed for swift deployment, ensuring you can focus on network automation without delay.",
  },
  {
    title: "Highly scalable",
    desc: "Scale up at any time to support your business growth. Whether you're managing a small network or a large enterprise system, our platform scales to meet your network DevOps needs.",
  },
];

export const NETWORK_USE_CASE_LIST = [
  { name: "Lab On Demand", icon: BiNetworkChart },
  { name: "Automated Incident Reporting", icon: TbOutlineReportAnalytics },
  { name: "Automated Incident Handling", icon: TbOutlineSettingsAutomation },
  { name: "Configuration Backups", icon: MdOutlineRestorePage },
  { name: "Uptime/BGP Monitoring", icon: FiMonitor },
  { name: "Compliance Check", icon: GiMicroscope },
  { name: "Device Upgrades", icon: BiCloudUpload },
];

export const TECH_STACK_LIST = [
  {
    heading: "RedHat AAP Server (Trial)",
    content:
      "Ansible Automation Platform enables the automators to automate at enterprise scale more easily and flexibly.",
    icon: GiServerRack,
  },
  {
    heading: "GitLab Server Community Edition",
    content:
      "GitLab Community Edition Server (CE) is a web-based DevOps lifecycle tool that includes Git repository management, issue tracking, CI/CD pipelines, code review, an IDE, activity streams, wikis, and more.",
    icon: IoServerOutline,
  },
  {
    heading: "Rundeck Server",
    content:
      "Rundeck is a centralized console for managing the automation in your environment.",
    icon: AiOutlineCloudServer,
  },
  {
    heading: "Windows Jump Server",
    content:
      "A Jump Server is a pre-configured windows 2019 Host with a set of applications like Putty, various browsers, Wireshark, etc. pre-installed on the host. The Jump host can also be Leveraged to be used as a DHCP/AD/DNS server for your lab Environment.",
    icon: TbOutlineCloudComputing,
  },
  {
    heading: "Network Emulator",
    content:
      'We offer <a href="https://cloudmylab.com/services/hosted-emulators/eve-ng" style="color: #007FFF" target="blank">EVE-NG Professional</a> or <a href="https://cloudmylab.com/services/hosted-emulators/cisco-modeling-labs" style="color: #007FFF" target="blank">Cisco Modeling Labs</a> to simulate a network environment seamlessly connecting you to the development environment. EVE-NG is one of the most efficient <a href="https://cloudmylab.com/services/hosted-emulators" style="color: #007FFF" target="blank">network emulators</a>  in the industry.',
    icon: BsFillHddNetworkFill,
  },
];

export const OFFERING_TABLE_DATA = {
  product: "Ansible",
  base: {
    os: "Ansible",
    plan: "ANSIBLE-BASE",
    vcpu: 32,
    memory: "128 GB",
    disk: "480 GB",
    ips: 1,
    users: 2,
    yearlyPrice: {
      price: "$3990.00",
      id: "ANSIBLE-BASE-USD-Yearly",
      frequency: "1_year",
    },
    monthlyPrice: {
      price: "$399.00",
      id: "ANSIBLE-BASE-USD-Monthly",
      frequency: "1_month",
    },
  },
  pro: {
    os: "Ansible",
    plan: "ANSIBLE-PRO",
    vcpu: 48,
    memory: "256 GB",
    disk: "960 GB",
    ips: 5,
    users: 4,
    yearlyPrice: {
      price: "$6990.00",
      id: "ANSIBLE-PRO-USD-Yearly",
      frequency: "1_year",
    },
    monthlyPrice: {
      price: "$699.00",
      id: "ANSIBLE-PRO-USD-Monthly",
      frequency: "1_month",
    },
  },
  expert: {
    os: "Ansible",
    plan: "ANSIBLE-EXPERT",
    vcpu: 80,
    memory: "512 GB",
    disk: "1.8 TB",
    ips: 9,
    users: 8,
    yearlyPrice: {
      price: "$10990.00",
      id: "ANSIBLE-EXPERT-USD-Yearly",
      frequency: "1_year",
    },
    monthlyPrice: {
      price: "$1099.00",
      id: "ANSIBLE-EXPERT-USD-Monthly",
      frequency: "1_month",
    },
  },
};

export const BASE_CONFIG_DATA = {
  cpu: {
    gitlab: 4,
    aap: 4,
    runDeck: 4,
    jumpBox: 4,
    networkEmulator: 16,
  },
  memory: {
    gitlab: 8,
    aap: 16,
    runDeck: 16,
    jumpBox: 8,
    networkEmulator: 96,
  },
  disk: {
    gitlab: 20,
    aap: 40,
    runDeck: 40,
    jumpBox: 60,
    networkEmulator: 340,
  },
};

export const EXPERT_CONFIG_DATA = {
  cpu: {
    gitlab: 4,
    aap: 8,
    runDeck: 8,
    jumpBox: 4,
    networkEmulator: 24,
  },
  memory: {
    gitlab: 16,
    aap: 32,
    runDeck: 32,
    jumpBox: 16,
    networkEmulator: 160,
  },
  disk: {
    gitlab: 40,
    aap: 80,
    runDeck: 80,
    jumpBox: 100,
    networkEmulator: 700,
  },
};

export const PRO_CONFIG_DATA = {
  cpu: {
    gitlab: 4,
    aap: 8,
    runDeck: 8,
    jumpBox: 4,
    networkEmulator: 24,
  },
  memory: {
    gitlab: 16,
    aap: 32,
    runDeck: 32,
    jumpBox: 16,
    networkEmulator: 160,
  },
  disk: {
    gitlab: 40,
    aap: 80,
    runDeck: 80,
    jumpBox: 100,
    networkEmulator: 700,
  },
};

export const SERVER_CONFIG_LIST = [
  {
    content:
      " You get a Private cloud Server with the following Virtual Machines (32vCPU | 128 GB Memory | 480 GB DISK)",
    data: BASE_CONFIG_DATA,
    title: "Base - Server Config",
  },
  {
    content:
      "You get a Private cloud Server with the following Virtual Machines (48vCPU | 256 GB Memory | 960 GB DISK)",
    data: PRO_CONFIG_DATA,
    title: "Pro - Server Config",
  },
  {
    content:
      "You get a Private cloud Server with the following Virtual Machines (80vCPU | 512 GB Memory | 1.8 TB DISK)",
    data: EXPERT_CONFIG_DATA,
    title: "Expert - Server Config",
  },
];

export const SERVICES_LIST = [
  {
    content: "Reduce your planning cycles from several months to a few weeks.",
  },
  {
    content:
      "Alleviate your challenge by bringing our infrastructure and network expertise to build and deliver your projects swiftly.",
  },
  {
    title: "Certified Engineers :",
    content: "Work with our Network Automation Stack Certified Engineers.",
  },
  {
    content: "Part-time, full-time, and one-time resources available.",
  },
  {
    title: "Professional CI/CD Pipelines :",
    content:
      "Get a professionally built, well-documented CI/CD pipeline tailored for your network operations.",
  },
  {
    content: "24/7 Professional Services Support.",
  },
  {
    title: "Dedicated Project Managers :",
    content:
      "Benefit from dedicated project managers ensuring your projects stay on track.",
  },
];
